"use client";

import cls from "./HeaderPopover.module.css"
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useRef, RefObject } from "react";

interface HeaderPopoverProps {
    isOpen: boolean;
    links: Array<{ label: string; href: string }>;
    onClose: () => void;
    triggerRef: RefObject<HTMLButtonElement | null>;
    className?: string;
}

export const HeaderPopover = ({ isOpen, links, onClose, triggerRef, className }: HeaderPopoverProps) => {
    const currentRoute = usePathname();
    const popoverRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node;

            if (
                popoverRef.current && 
                !popoverRef.current.contains(target) &&
                triggerRef.current &&
                !triggerRef.current.contains(target)
            ) {
                onClose();
            }
        };

        if (isOpen) {
            const timeoutId = setTimeout(() => {
                document.addEventListener("mousedown", handleClickOutside);
            }, 0);

            return () => {
                clearTimeout(timeoutId);
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [isOpen, onClose, triggerRef]);

    return (
        <div 
            ref={popoverRef}
            className={`${cls.headerPopover} ${isOpen ? cls.open : ""} ${className ? className : ""}`}
        >
            {links && (
                <ul className={cls.linksList}>
                    {links.map((link) => (
                        // <li key={link.href} className={`${cls.linkItem} ${currentRoute === link.href ? cls.active : ""}`}>
                            <Link key={link.href} href={link.href} className={`${cls.linkItem} ${currentRoute === link.href ? cls.active : ""}`}>{link.label}</Link>
                        // </li>
                    ))}
                </ul>
            )}
        </div>
    )
}